module.exports = __webpack_public_path__ + "static/media/orders_icon.33727fb8.svg";